import { InputField } from "kubra-ux-forge";
import React from "react";
import { useField } from "formik";
import { getWcagAutocompleteValue } from "utilities/wcag";

interface EmailAddressProps {
  name: string;
  label: string;
  placeholder?: string;
  editableIfPrefilled?: boolean;
}

export const EmailAddress: React.FC<EmailAddressProps> = ({
  label,
  name,
  placeholder,
  editableIfPrefilled,
}) => {
  const [field, meta] = useField(name);

  let disabled = false;

  if (meta.initialValue && !editableIfPrefilled) {
    disabled = true;
  }

  return (
    // TODO: use appropriate class.
    <div className="bank-account-name-textbox-container">
      <InputField
        {...field}
        errorText={meta.touched ? meta.error : undefined}
        hasError={meta.touched ? !!meta.error : false}
        aria-invalid={meta.touched && !!meta.error}
        label={label}
        dataCy={name}
        placeholder={placeholder}
        autoComplete={getWcagAutocompleteValue(name, label)}
        disabled={disabled}
      />
    </div>
  );
};
